import { images } from '../constants';

const timelineData = [
    {
        id: 1,
        phase: '1914 - 1918',
        titleKey: 'timeline.item1.title',
        textKey: 'timeline.item1.text',
        image: images.kolej1,
        captionKey: 'timeline.item1.caption'
    },
    {
        id: 2,
        phase: 'Lata 20. i 30. XX w.',
        titleKey: 'timeline.item2.title',
        textKey: 'timeline.item2.text',
        image: images.kolej2,
        captionKey: 'timeline.item2.caption'
    },
    {
        id: 3,
        phase: '1939 - 1945',
        titleKey: 'timeline.item3.title',
        textKey: 'timeline.item3.text',
        image: images.kolej3,
        captionKey: 'timeline.item3.caption'
    },
    {
        id: 4,
        phase: 'Lata 50. XX w.',
        titleKey: 'timeline.item4.title',
        textKey: 'timeline.item4.text',
        image: images.kolej4,
        captionKey: 'timeline.item4.caption'
    },
    {
        id: 5,
        phase: '1970 - 2001',
        titleKey: 'timeline.item5.title',
        textKey: 'timeline.item5.text',
        image: images.kolej5,
        captionKey: 'timeline.item5.caption'
    },
    {
        id: 6,
        phase: '2002 - 2011',
        titleKey: 'timeline.item6.title',
        textKey: 'timeline.item6.text',
        image: images.kolej6,
        captionKey: 'timeline.item6.caption'
    },
    {
        id: 7,
        phase: 'Od 2019',
        titleKey: 'timeline.item7.title',
        textKey: 'timeline.item7.text',
        image: images.kolej7,
        captionKey: 'timeline.item7.caption'
    }
];

export default timelineData;